import { loader } from "graphql.macro";

export const ContentQuery = loader("./ContentQuery.graphql");
export const StreamPreviewQuery = loader("./StreamPreviewQuery.graphql");
export const StreamPreviewStatusQuery = loader(
  "./StreamPreviewStatusQuery.graphql"
);
